<template>
  <div>
    <header id="masthead" class="allP subpage">
      <div class="wp1200 topBar">
        <router-link v-if="user" :to="{ name: 'dashboard' }" class="logo">
             Episcenter Klub
        </router-link>
        <router-link v-if="!user" :to="{ name: 'home' }" class="logo">
          Episcenter Klub
        </router-link>
        <span v-if="showMobileRightMenu"
            class="icon menu-button show"
            v-bind:class="{
            ' warpit_icon_hamburger': closeNavigation,
            ' warpit_icon_MINUS': !closeNavigation,
          }"
            v-on:click="menuButtonClicked()"
        >
          <span class="notification"></span>
        </span>
          <router-link :to="{ name: 'surveys' }" v-if="showMobileRightMenu">
            <a class="surveyIcon">
              <span class="icon warpit_icon_survey">
                <span class="notification"></span>
              </span>
            </a>
          </router-link>
        <Navigation v-bind:active_el="activeEl"
                    v-bind:closeNavigation="closeNavigation"></Navigation>
      </div>
      <div class="wp1200">
        <hr class="blue header" />
        <h4>{{title}}</h4>
        <div class="tab" v-if="tabs.length > 0">
          <button v-for="(tab, index) in tabs"
           :key="index"
            class="tablinks"
            v-bind:class="{ 'active': tab.index === tabActive }"
            v-on:click.prevent="changeTab(tab.index)"
          >
            {{tab.name }}
          </button>
        </div>
      </div>
      <div class="blueTriangleHead"></div>
      <div class="containerHead"></div>
    </header>
  </div>
</template>
<script>
import Navigation from "../Navigation.vue";
export default {
  props: {
    title:String,
    activeEl:Number,
    tabs:{
      type: Array,
      default: () => [],
    },
    showMobileRightMenu:{
      type:Boolean,
      default:true
    }
  },
  data() {
    return {
      tabActive:1,
      notCompleted: true,
      closeNavigation: true,
    };
  },
  computed: {
    user() {
      return this.$store.getters["user/user"];
    }
  },
  components: { Navigation },
  mounted() {},
  methods: {
    menuButtonClicked() {
      this.closeNavigation = this.closeNavigation === true ? false : true;
      this.$emit("menuButtonClicked", this.closeNavigation);
    },
    changeTab(index) {
      this.tabActive = index;
      this.$emit("tabSelectedChange", index);
    }
  },
};
</script>